import React, {
    createContext,
  } from 'react';
import socketio from "socket.io-client";

export const socket = socketio.connect("https://api-web.lognlook.com/", {transports: [ 'websocket' ]});
export const SocketContext = createContext();